import { gql } from '@apollo/client';
export const setCallExcludedFromPerformanceMetricsMutation = gql `
  mutation setCallExcludedFromPerformanceMetrics($callID: String!, $excluded: Boolean!) {
    setCallExcludedFromPerformanceMetrics(callID: $callID, excluded: $excluded)
  }
`;
